<template>
  <el-dialog title="调整城市公司" :visible.sync="formVisible" :close-on-click-modal="false" width="800px" v-if="formVisible">
    <el-form class="form-custom" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="调整城市公司：" prop="newCityCompanyId">
        <el-select v-model="form.newCityCompanyId" filterable clearable remote placeholder="请输入城市公司搜索" :remote-method="searchUsers" :loading="loading">
          <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="handleAdd">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import clientListApi from '@/api/client/clientList'
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  data() {
    return {
      value: '',
      formVisible: false,
      form: { newCityCompanyId: '' },
      formRules: {
        newCityCompanyId: [{ required: true, message: '请选择城市公司', trigger: 'change' }],
      },
      cityCompanyOptions: [],
      query: {
        pageNo: 1,
        pageSize: 100
      },
      rowItem: null,
    }
  },
  created() {
  },
  methods: {

    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getList(query)
        }, 500);
      } else {
        this.getList()
      }
    },
    getList(query) {
      cityCompanyApi.fetchList({ cityCompanyName: query, pageNo: 1, pageSize: 100, state: 1 }).then(data => {
        this.cityCompanyOptions = data.data.list;
      })
    },
    handleUpdate(row) {
      this.getList()
      this.form.newCityCompanyId = row.cityCompany ? row.cityCompany.id : '';
      this.rowItem = row;
      this.isRepSub = false;
      this.formVisible = true
    },
    async handleAdd() {
      let find = this.cityCompanyOptions.find(item => item.id === this.form.newCityCompanyId)
      const { data } = await clientListApi.getUserWallet({ customerId: this.rowItem.customer.id })

      this.$confirm(`当前用户剩余零售价：${data.xiaoduMoney}，余额账户：${data.balance}，赠送账号：${data.userId}将发生余额调账；`, '是否确认调整城市公司', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitForm()
      }).catch(() => {

      });
    },
    submitForm() {
      let params = {
        id: this.rowItem.customer.id,
        newCityCompanyId: this.form.newCityCompanyId,
      }
      if (this.isRepSub) return
      this.isRepSub = true
      clientListApi.updateCityCompany(params).then(res => {
        if (res.code === '0') {
          this.$message.success('操作成功')
          this.submitHint()
        }
      }).catch(res => {
        this.isRepSub = false
      });
    },
    async submitHint() {
      let { customer } = this.rowItem
      let { data } = await clientListApi.checkCityCompany({ customerid: customer ? customer.id : '', cityCompanyId: this.form.newCityCompanyId })
      if (data.isChaoChu) {
        this.$confirm(`客户归属城市公司已修改，是否需要同步修改所属区域`, '提示', {
          confirmButtonText: '同步修改',
          cancelButtonText: '暂不修改',
          type: 'warning'
        }).then(() => {
          this.formVisible = false;
          this.$emit('created', 1, this.rowItem)
        }).catch(() => {
          this.formVisible = false;
          this.$emit('created')
        });
      } else {
        this.formVisible = false;
        this.$emit('created')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  display: flex;
}
::v-deep .el-select {
  width: 100%;
}
.el-button {
  margin-left: 5px;
}
</style>
